<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM14,14C14,14,2,14,2,14C2,14,2,11,2,11C2,11,14,11,14,11C14,11,14,14,14,14C14,14,14,14,14,14ZM14,10C14,10,2,10,2,10C2,10,2,2,2,2C2,2,14,2,14,2C14,2,14,10,14,10C14,10,14,10,14,10ZM6,7C6,7,10,7,10,7C10.55,7,11,6.55,11,6C11,5.45,10.55,5,10,5C10,5,6,5,6,5C5.45,5,5,5.45,5,6C5,6.55,5.45,7,6,7C6,7,6,7,6,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'RemoveRowTop',
} as DefineComponent
</script>
